(function () {
    'use strict';

    angular
        .module('app.helpText')
        .controller('HelpTextListController', HelpTextListController);

    HelpTextListController.$inject = ['common', 'dataservice', 'config'];
    /* @ngInject */
    function HelpTextListController(common, dataservice, config) {
        var vm = this;
        vm.title = 'Help Text';
        vm.displayedItems = [];
        vm.items = [];

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            });
        }

        function getItems() {
            return dataservice.getItems('api/HelpText').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }
    }
})();
